import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import PitchPage from "./pages/PitchPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import PitchEditor from "./pages/admin/PitchEditor";
import ChangePassword from "./pages/admin/ChangePassword";
import { AuthProvider, RequireAdmin } from "./context/AuthContext";
import { AdminShell } from "./components/admin/AdminShell";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/p/river-city-cruises" replace />} />
        <Route path="/p/:slug" element={<PitchPage />} />
        <Route path="/admin" element={<AuthProvider />}>
          <Route path="login" element={<AdminLogin />} />
          <Route element={<RequireAdmin><AdminShell /></RequireAdmin>}>
            <Route index element={<AdminDashboard />} />
            <Route path="new" element={<PitchEditor />} />
            <Route path="edit/:slug" element={<PitchEditor key="edit" />} />
            <Route path="password" element={<ChangePassword />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
